import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { forkJoin, from, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class I18nRestService {
  constructor(private restService: RestService) {}

  getCheckedInTranslations(lang: string): Observable<any> {
    return from(this.restService.get$$(`/locale/${lang.toLocaleLowerCase()}.json?build=${environment.buildDate}`, 'asset'));
  }

  getServerTranslations(lang: string | string[]): Observable<any> {
    if (Array.isArray(lang)) {
      const observables = (lang as string[]).map(language => this.restService.get(`/Translation/get?id=${language.toLocaleLowerCase()}&build=${environment.buildDate}`));
      return forkJoin(observables);
    } else {
      return this.restService.get(`/Translation/get?id=${lang.toLocaleLowerCase()}`).pipe(
        catchError(error => {
          return of(null);
        })
      );
    }
  }

  saveOrUpdateTranslations(lang: string, translations: any): Observable<any> {
    return this.restService.post('/Translation/createOrUpdate', { id: lang.toLocaleLowerCase(), json: translations });
  }
}
